export const ALL_MEDICAL_RECORDS_REQUEST = 'ALL_RECORDS';
export const MEDICAL_RECORD_REQUEST = 'RECORD';
export const CLAIM_INVOICE_REQUEST = 'INVOICE';
